import { Component, Input, OnInit } from '@angular/core';
import { CPPOrderSplitDetails } from './../../../models/CPP/CPPOrderSummaryVM';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-blanket-grid-view',
  templateUrl: './blanket-grid-view.component.html',
  styleUrls: ['./blanket-grid-view.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class BlanketGridViewComponent implements OnInit {
  lineStatus: any;
  gridDataList: any;
  plAccess = false;
  isBulk = false;
  masterConstants = MasterConstants;
  @Input()
  set gridData(val: CPPOrderSplitDetails) {
    this.gridDataList = val.productDetail;
  }
  get gridData(): CPPOrderSplitDetails {
    return this.gridDataList;
  }

  displayedColumns: string[] = ['product', 'flashmsg', 'detail', 'quantity', 'orderUOM', 'packageSize'];
  displayedFooterColumns: string[] = this.displayedColumns;

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.lineStatus = this.gridDataList[0].lineStatus;
    if (this.lineStatus == 'OPEN' || this.lineStatus == 'CLOSED') {
      this.displayedColumns = ['product', 'detail', 'quantity', 'quantityRemaining', 'quantityCanceled', 'orderUOM', 'packageSize'];
    }
    this.isBulk = this.gridDataList.some(x => x.bulkPackaged == 'bulk' || x.bulkPackaged == 'BULK');
    if (this.isBulk) {
      this.displayedColumns.push('bulkrequesteddate');
    }

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // Total price of all the items in the grid displayed
  getTotalPrice() {
    let totalPrice = 0;
    this.gridDataList.forEach(x => {
      totalPrice += x.totalPrice;
    });
    return totalPrice;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    if (item.lineStatus == 'CANCELLED') {
      return;
    }
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
